import { _APP_CONFIG } from "../../core/config/AppConfig";
import { DataDRequest } from "../DRequest";
import { IFinanzaPagoRecibidoCargo } from "../entidad/FinanzaIngresoPagoRecibido";

/** Los Detalles por cargo pagado incluyen Pagos (Completos y Parciales) y Descuentos */
export async function _SvFinanzasObtenerPagosRecibidos(idEscuela: number): Promise<DataDRequest.IRequestResponseA<IFinanzaPagoRecibidoCargo[]>> {
    const url = _APP_CONFIG.URL_RSTV2 + "finanzas/ObtenerPagos";
    const params = {
        IdEscuela: idEscuela
    }
    return DataDRequest._Request5(url, "GET", params, {
        idToKeepPromiseUntilFinished: idEscuela
    })
}
